<template>
    <section>
        <br />
        <div class="story-text mt-30 text-start">
            <i class="fa-solid fa-quote-left"></i>
            <i class="fa-solid fa-quote-right"></i>
            <p>
                Mon rôle est de faciliter le développement des compétences des individus au sein
                de
                votre organisation.
            </p>
            <p class="mt-20 mb-20">
                Pour cela, je vous accompagne tout au long de ce projet de formation
                :
            </p>
            <div class="mt-20 mb-20 text-start">

            </div>
        </div>
        <div class="d-flex gap-3 mobile">
            <div class="story-text story-text-section text-start">
                <div class="mt-20 mb-20">
                    <ul>
                        <li class="mb-3"><strong>1. Analyse des besoins de formation : </strong>Nous allons
                            construire
                            ensemble votre projet de formation, lors d’entretiens téléphoniques ou
                            visio.
                            Ces échanges d’informations sont indispensables pour bien définir et
                            comprendre
                            votre projet.</li>
                        <li class="mb-3"><strong>2. Programmes de formation : </strong>Sur la base de vos besoins
                            identifiés, je vous orienterai vers le ou les programmes de formation
                            adaptés.
                            Cela peut même inclure la création de modules de formation s’il y a une
                            demande
                            sur mesure.</li>
                        <li class="mb-3"><strong>3. Mise en œuvre : </strong>Après validation de la formation, je
                            m’occuperai de la coordination des sessions de formation, de la mise en
                            place du
                            financement, de la gestion des ressources nécessaires et du déroulement des
                            formations.</li>
                        <li class="mb-3"><strong>4. Suivi et évaluation : </strong>Pour finir, je récupèrerai les
                            feedbacks en analysant les résultats des questionnaires remplis par les
                            stagiaires et formateurs.</li>
                    </ul>
                </div>
                <p class="mt-70 mb-20">
                    <span class="bold resume">En résumé, je gère votre projet de formation de A à Z, et veille à son bon
                        déroulement.</span>
                </p>
            </div>
            <div class="story-img-section">
                <div class="story-img mb-3">
                    <img src="/images/pages/organisme-formation/christie CLAVIER.png" alt="Christie CLAVIER">
                </div>
                <div class="founderName d-flex flex-column justify-content-center align-items-center">
                    <span>Christie CLAVIER</span>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>

</script>
<style scoped>
.story-text p {
    color: #25233E;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
}

.story-img img {
    vertical-align: middle;
    width: 680px;
    height: 433px;
    border-radius: 50%;
    -o-object-fit: cover;
    object-fit: cover;
}

.founderName span {
    color: #318EC7;
    text-align: center;
    font-family: Nunito;
    font-size: 29px;
    font-style: normal;
    font-weight: 500;
    line-height: 111.5%;
    /* 32.335px */
    letter-spacing: -0.435px;
}


.fa-quote-right,
.fa-quote-left {
    color: #83C1E8;
    font-size: 128px;
    position: absolute;
}

.fa-quote-left {

    top: 15%;
    left: 5%;
}

.fa-quote-right {
    top: 32%;
    left: 85%;
}

span[class='bold'] {
    font-weight: 600;
    font-size: 34px;
    font-family: 'Nunito';
}

section {
    background: #FFF;
    padding: 0px 50px;
    border-radius: 20px;
}

.resume {
    font-weight: bold;
}

.story-text-section {
  width: 60%;
}

.story-img-section {
  width: 40%;
}

/* Styles pour les écrans de petite taille (S) */
@media (max-width: 320px) {
    .fa-quote-left {
        top: 13.25%;
        left: 12%;
    }

    .fa-quote-right {
        top: 36.5%;
        left: 80%;
    }
}

@media (min-width: 375px) and (max-width:424px) {
    .fa-quote-left {
        top: 13.25%;
        left: 9%;
    }

    .fa-quote-right {
        top: 35.05%;
        left: 80%;
    }
}

@media (min-width: 425px) and (max-width:767px) {
    .fa-quote-left {
        top: 12.5%;
        left: 9%;
    }

    .fa-quote-right {
        top: 34.25%;
        left: 84%;
    }
}

@media (min-width: 768px) and (max-width:1023px) {
    .fa-quote-left {
        top: 16.5%;
        left: 64px;
    }

    .fa-quote-right {
        top: 39.05%;
        left: 84%;
    }

    .fa-quote-right,
    .fa-quote-left {
        font-size: 45px;
    }
}

@media (min-width: 1242px) and (max-width:1279px) {
    .fa-quote-left {
        top: 16.5%;
        left: 64px;
    }

    .fa-quote-right {
        top: 39.05%;
        left: 84%;
    }

    .fa-quote-right,
    .fa-quote-left {
        font-size: 45px;
    }
}

@media (min-width: 1000px) and (max-width:1022px) {
    .fa-quote-left {
        top: 21.5%;
        left: 103px;
    }

    .fa-quote-right {
        top: 39.05%;
        left: 84%;
    }

    .fa-quote-right,
    .fa-quote-left {
        font-size: 45px;
    }
}

@media (min-width: 1024px) and (max-width:1279px) {
    .fa-quote-left {
        top: 18.5%;
        left: 13%;
    }

    .fa-quote-right {
        top: 33.05%;
        left: 94%;
    }

    .fa-quote-right,
    .fa-quote-left {
        font-size: 57px;
    }

    .resume {
        font-weight: bold;
    }
}

@media (min-width: 1027px) and (max-width:1260px) {
    .fa-quote-left {
        top: 18.75%;
        left: 9%;
    }

    .fa-quote-right {
        top: 33.05%;
        left: 84%;
    }

    .fa-quote-right,
    .fa-quote-left {
        font-size: 57px;
    }

    .resume {
        font-weight: bold;
    }
}

@media (min-width: 1652px) and (max-width:1692px) {
    .fa-quote-left {
        top: 18.75%;
        left: 1%;
    }

    .fa-quote-right {
        top: 30.05%;
        left: 90%;
    }
}

@media (min-width: 1280px) and (max-width:1439px) {
    .fa-quote-left {
        top: 16.75%;
        left: 3%;
    }

    .fa-quote-right {
        top: 34.05%;
        left: 94%;
    }

    .fa-quote-right,
    .fa-quote-left {
        font-size: 70px;
    }

    .resume {
        font-weight: bold;
    }
}


/* Styles pour les écrans de petite taille (S) */
@media only screen and (max-width: 1024px) {

    .fa-quote-right,
    .fa-quote-left {
        font-size: 28px;
    }

    .mobile {
        flex-direction: column-reverse;
    }

    .story-img img {
      //height: 380px;
      width: unset;
      margin: auto;
    }

  .story-text-section {
    width: unset;
  }

  .story-img-section {
    width: unset;
  }

    ul li {
        font-size: 14px;
    }

    .resume {
        font-size: 16px;
        font-weight: bold;
    }
}


/* Styles pour les écrans de taille moyenne (M) */
@media only screen and (min-width: 600px) and (max-width: 768px) {
    .section-padding[data-v-d01dfef2] {
        padding: 70px 10px;
    }
}

@media only screen and (min-width: 769px) and (max-width: 991px) {}

@media only screen and (min-width: 1000px) and (max-width: 1024px) {
    .section-padding[data-v-d01dfef2] {
        padding: 70px 80px;
    }
}

@media only screen and (min-width: 1025px) and (max-width: 1087px) {}

@media only screen and (min-width: 1088px) and (max-width: 1872px) {}

@media only screen and (min-width: 1450px) and (max-width: 1800px) {}
</style>